import { Field, Form, Formik } from "formik";

import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import Title from "../../components/common/title/Title";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { useEffect, useRef, useState } from "react";
import { giftOrderValidation } from "../../utils/validations/giftOrderValidation";
import RolesSelect from "../../components/common/inputs/RolesSelect";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import Select from "../../components/common/inputs/Select";

export default function CampainOrderGiftDiscountForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);
  const [roles, setRoles] = useState([]);

  const formHandler = async (values, { resetForm }) => {
    const body = {
      ...values,
      gtePrice: Number(values.gtePrice),
      roles,
    };
    try {
      if (!location?.state) {
        await postApi({
          path: "admin/orderGifts",
          body: JSON.stringify(body),
        });
        successMessage("محصولات هدیه با موفقیت اضافه شد");
        resetForm();
      } else {
        await putApi({
          path: `admin/orderGifts/${location?.state.id}`,
          body: JSON.stringify(body),
        });
        successMessage("اطلاعات محصولات هدیه با موفقیت آپدیت شد.");
      }
      navigate("/gift-order-product-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const roleRef = useRef();

  const handleRoles = (data) => {
    setRoles(data);
  };

  useEffect(() => {
    if (location?.state?.roles?.length) {
      setRoles(location?.state?.roles);
    }
  }, [location?.state]);

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title
        title={!location.state ? "افزودن محصولات هدیه" : "ویرایش محصولات هدیه"}
      />
      <Formik
        enableReinitialize
        initialValues={
          location.state
            ? {
                name: location?.state?.name || "",
                status: location?.state?.status || "active",
                gtePrice: location?.state?.gtePrice || "",
                productSku: location?.state?.productSku || "",
              }
            : {
                name: "",
                status: utils?.LEARN_STATUS_VALUES[0]?.value || "active",
                gtePrice: 0,
                productSku: "",
              }
        }
        validationSchema={giftOrderValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input
                  name={"name"}
                  placeholder={"نام نمادین را وارد کنید"}
                  label={"نام"}
                  type="text"
                />
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    کف قیمت
                  </label>
                  <CurrencyInput
                    name={"gtePrice"}
                    inputValue={formik.values["gtePrice"]}
                    placeholder={"به تومان وارد کنید"}
                    label={"حداقل مبلغ فاکتور قدیم"}
                    onChange={(e) => formik.setFieldValue("gtePrice", e)}
                  />
                </div>
                <Input
                  name={"productSku"}
                  placeholder={"شناسه محصول را وارد کنید"}
                  label={"شناسه محصول را وارد کنید"}
                  type={"text"}
                />
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    انتخاب نقش
                  </label>
                  <RolesSelect
                    oldRoles={location?.state?.roles}
                    ref={roleRef}
                    onChange={handleRoles}
                  />
                </div>
                <Field
                  as="select"
                  name="status"
                  label="وضعیت"
                  component={Select}
                >
                  {utils
                    ? utils?.ORDER_GIFT_STATUS_VALUES?.map((item) => {
                        return <option value={item.value}>{item.name}</option>;
                      })
                    : null}
                </Field>
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="flex items-center gap-2 mt-6">
                  <Button
                    type="submit"
                    text={location?.state ? "ویرایش" : "افزون"}
                    color={"success"}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
